import { AxiosError } from 'axios';
import { GET_APPLICATION_FILES_CONFIG_URL } from '../../constants/apiUrls';
import { GET_APPLICATION_FILES_CONFIG_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ApplicationFilesConfigResponse {
  fileSizeLimit: number;
  fileNumLimit: number;
  uploadFileTypes: string[];
  dimensionLimit?: string;
  uploadDocumentType: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  applicationType: string;
  onSuccess?: (data: ApplicationFilesConfigResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetApplicationFilesConfigPassportPhoto = ({
  applicationType,
  onSuccess,
  onError,
}: Input) => {
  const getApplicationFilesConfigPassportPhoto = async () => {
    const res = await axiosClient.get<ApplicationFilesConfigResponse[]>(
      GET_APPLICATION_FILES_CONFIG_URL(applicationType)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_APPLICATION_FILES_CONFIG_QUERY_KEY],
    getApplicationFilesConfigPassportPhoto,
    {
      onSuccess,
      onError,
    }
  );
};
